<template>
  <section>
    <app-loading v-if="loading" />

    <div v-else>
      <!-- Filter -->
      <div class="intro-y flex flex-col-reverse sm:flex-row items-center mt-10">
        <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
          <h2 class="intro-y text-lg font-medium mr-auto mt-2">
            Actividades ({{ activities.length }})
          </h2>
        </div>
        <div class="w-full sm:w-auto flex">
          <button @click="toggleModalMessage(true)" class="button text-white bg-theme-1 shadow-md mr-2">
            Mensaje Inxapp
          </button>
          <router-link to="/admin/points" class="button text-white bg-theme-1 shadow-md mr-2">
            Ver Puntos
          </router-link>

          <router-link to="/admin/activities/create" class="button text-white bg-theme-1 shadow-md mr-2">
            Crear Actividad
          </router-link>
        </div>
      </div>
      <!-- END: Filter -->

      <!-- List -->
      <div class="overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="text-center whitespace-no-wrap">NOMBRE / DESCRIPCION</th>
              <th class="text-center whitespace-no-wrap">ARCHIVOS</th>
              <th class="text-center whitespace-no-wrap">TIPO / ESTADO</th>
              <th class="text-center whitespace-no-wrap">FECHAS VIGENCIA</th>
              <th class="text-center whitespace-no-wrap">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="intro-x" v-for="activity in activities" :key="`activity-${activity.slug}`">
              <td class="w-40 text-center">
                <div class="text-gray-900 font-bold text-xs whitespace-no-wrap">
                  {{ activity.name | limit}}
                </div>
                <div class="text-gray-500 text-xs whitespace-no-wrap">
                    {{ activity.description | limit }}
                  </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  Imagen: <br>
                  <a :href="activity.image" target="_blank" v-if="activity.image" class="text-blue-600 underline">
                    Ver imagen
                  </a>
                  <br><br>
                  Material de estudio: <br>
                  <a :href="activity.study_information" target="_blank" v-if="activity.study_information" class="text-blue-600 underline">
                    Ver archivo
                  </a>
                </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-900 font-bold text-xs whitespace-no-wrap">
                  {{ activity.type }}
                  </div>
                  <div class="text-gray-600 text-xs whitespace-no-wrap">
                    {{ activity.status_name }}
                  </div>
              </td>
              <td class="w-40 text-center">
                <div class="text-gray-600 text-xs whitespace-no-wrap">
                  Fecha inicial: <br>
                  {{ activity.start_date }} <br><br>
                  Fecha final: <br>
                  {{ activity.end_date }}
                </div>
              </td>
              <td class="table-report__action w-56">
                <div class="flex justify-center items-center">
                  <button @click="editActivity(activity)"
                    class="flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs">
                    <app-icon name="edit" classname="w-4 h-4 mr-2" />Editar actividad
                  </button>
                </div>
                <div class="flex justify-center items-center" v-if="activity.type !== 'Extra'">
                  <router-link :to="`/admin/activities/${activity.slug}/questions`"
                    class="flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs">
                    <app-icon name="table" classname="w-4 h-4 mr-2" />Editar preguntas
                  </router-link>
                </div>
                <div class="flex justify-center items-center">
                  <router-link :to="`/admin/activities/${activity.slug}`"
                    class="flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs">
                    <app-icon name="clipboard" classname="w-4 h-4 mr-2" />Detalle
                  </router-link>
                </div>
                <div class="flex justify-center items-center">
                  <router-link :to="`/admin/activities/${activity.slug}/participations`"
                    class="flex items-center block py-1 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md text-xs">
                    <app-icon name="eye" classname="w-4 h-4 mr-2" />Participaciones
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ModalEditActivity v-if="show_activity_model"
        @close="closeEditActivity"
        :current_activity="current_activity"/>

      <ModalMessage v-if="modalMessage" @close="toggleModalMessage(false)" />
      <!-- END: List -->
    </div>
  </section>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Icon from '@/components/admin/partials/Icon'
  import Loading from '@/components/admin/partials/LoadingWhite'
  import ModalEditActivity from '@/components/admin/activity/ModalEditActivity'
  import ModalMessage from '@/components/admin/report/ModalMessage'

  export default {
    name: 'AdminListActivity',
    data () {
      return {
        loading: false,
        current_activity: {},
        show_activity_model: false,
        modalMessage: false
      }
    },
    computed: {
      ...mapGetters({
        activities: 'getActivities',
      }),
    },
    async beforeMount () {
      this.loading = true
      try {
        await this.getAll('activity')
      } finally {
        this.loading = false
      }
    },
    methods: {
      ...mapActions([
        'getAll',
      ]),
      editActivity (activity) {
        this.current_activity = activity
        this.show_activity_model = true
      },
      closeEditActivity () {
        this.current_activity = {}
        this.show_activity_model = false
      },
      toggleModalMessage(status) {
        this.modalMessage = status
      },
    },
    components: {
      appIcon: Icon,
      appLoading: Loading,
      ModalEditActivity,
      ModalMessage
    },
  }
</script>



// WEBPACK FOOTER //
// ListActivity.vue?2fb1f9f2